<!-- <ion-content> -->
<!-- Body Content-->
<div class="pt-3 px-2 md:px-4 pb-8 safe-area-margin" aria-label="trial-list-container">
  <div class="flex align-items-center justify-content-between" aria-label="trial-list-header">
      <h1 data-cy="title" class="text-base md:text-lg flex align-items-center mb-0 line-height-1" data-cy="title" aria-label="trial-list-title">
        {{ 'Shared.PROSPECT.TRIALS' | translate }}
        <!-- <i class="fa fa-question-circle font-light text-xl text-600 cursor-pointer ml-2"
          pTooltip="{{ 'Shared.PROSPECT.PROSPECT_TOOLTIP' | translate }}" tooltipStyleClass="text-xs"></i> -->
          <a class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600" href="https://guides.unifiedfitnessplatform.ai/showcase/cluihfkkn07r84l520c2yyv8k" target="_blank" aria-label="help-guide-link" >
            <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
            <span class="ml-2 hidden md:inline-block">Help Guide for {{ 'Shared.PROSPECT.TRIALS' | translate }}</span>
            </a>
      </h1>
      <div (click)="OpenPopup()">
        <p-button icon="fa fa-plus" styleClass="md:hidden" aria-label="add-trial-button-mobile"></p-button>
        <p-button icon="fa fa-plus" label="{{'Shared.PROSPECT.ADD_NEW_TRIAL' | translate}}" styleClass="text-sm hidden md:inline-flex" aria-label="add-trial-button" ></p-button>
        </div>
  </div>

  <div class="shadow-2 surface-0 border-round mt-3" aria-label="trial-list-card">
    <div class="card relative mt-2 border-bottom-1 border-300 md:mt-0 px-3 md:px-2 pt-3 md:pt-2" aria-label="trial-list-content">
      <div class="flex flex-wrap align-items-center justify-content-between mb-2" aria-label="trial-list-header">
        <div class="mr-2 mb-2 md:mb-0" aria-label="total-trials">
          <span class="text-900 text-sm">{{ 'ADMIN.COMMON.TOTAL' | translate }} -  <strong>{{ totalItems | async }} </strong>{{ 'Shared.PROSPECT.TRIALS' | translate }}</span>
        </div>

        <div class="flex align-items-center justify-content-end">
          <!-- <div class="w-15rem md:w-11rem">
          <multi-select-staff [selected]="selectedStaffIds" (selectStaffEvent)="selectedStaffsData($event)" [placeholder]="'common.PLACEHOLDER.FILTER_BY_CLIENT_REP'">
          </multi-select-staff>
        </div> -->

            <!-- Filter -->
            <div class="ml-2 flex">
              <div>
              <div class="hidden md:inline-block" (click)="filterList.toggle($event)">
                <p-button [label]="'common.BUTTONS.BTN_MORE_FILTER' | translate " styleClass="p-button-outlined text-sm mr-2" icon="fa fa-filter" aria-label="more-filters-button" >
                </p-button>
              </div>
              <div class="md:hidden" (click)="filterList.toggle($event)">
                <p-button styleClass="p-button-outlined text-sm h-full" icon="fa fa-filter" aria-label="more-filters-button-mobile" >
                </p-button>
              </div>
  
              <p-popover #filterList styleClass="w-22rem md:w-25rem" aria-label="filter-panel">
                <ng-template #content>
                  <i (click)="filterList.hide($event)"
                    class="fa fa-times text-xl text-600 absolute right-0 top-0 cursor-pointer mt-3 mr-3" aria-label="close-filter" data-testid="close-filter"></i>
                  <!-- Dropdown Content -->
                  <div class="mb-3" aria-label="filter-content">
                    <!-- Date -->
                    <form [formGroup]="customFilterForm" aria-label="filter-form">
                      <h4 class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="trial-type-label">
                        {{ 'Shared.PROSPECT.MORE_FILTERS.TRIAL_TYPE' | translate }}
                      </h4>
                      <p-select [options]="trialTypes" formControlName="type" optionLabel="key"
                      [placeholder]="'Shared.PROSPECT.MORE_FILTERS.TRIAL_TYPE' | translate" styleClass="w-full text-sm" aria-label="trial-type-dropdown">
                        <ng-template pTemplate="selectedItem">
                          <div class="text-sm" *ngIf="selectedTypeFormControl">{{selectedTypeFormControl.value.key}}</div>
                        </ng-template>
                        <ng-template let-type pTemplate="item">
                          <div class="text-sm">{{type.key}}</div>
                        </ng-template>
                      </p-select>

                      <h4 class="font-medium text-700 text-xs mt-2 mb-2 block uppercase" aria-label="trial-status-label">
                          {{ 'Shared.PROSPECT.MORE_FILTERS.TRIAL_STATUS' | translate }}
                      </h4>

                      <p-select [options]="trialStatus" styleClass="w-full text-sm" formControlName="status" optionLabel="key"
                       [placeholder]="'Shared.PROSPECT.MORE_FILTERS.TRIAL_STATUS' | translate " aria-label="trial-status-dropdown">
                      <ng-template pTemplate="selectedItem">
                          <div class="text-sm" *ngIf="selectedStatusFormControl">{{ selectedStatusFormControl.value.key }}</div>
                      </ng-template>
                      <ng-template let-status pTemplate="item">
                        <div class="text-sm">{{ status.key }}</div>
                      </ng-template>
                    </p-select>

                    </form>
                  </div>
                  <!-- Dropdown Content -->
  
                  <!-- Dropdown Footer -->
                  <div
                    class="border-top-1 border-300 py-2 px-3 flex align-items-center justify-content-between -mb-3 -mx-3" aria-label="filter-footer">
                    <p-button label="{{ 'ADMIN.COMMON.RESET_FILTERS' | translate }}" styleClass="p-button-link text-sm"
                      pStyleClass="@grandparent" (click)="resetFilter(); filterList.hide($event)" enterFromClass="hidden"
                      enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" aria-label="reset-filters-button">
                    </p-button>
                    <button pButton pRipple label="{{ 'TASK_LIST.APPLY_FILTER' | translate }}" class="text-sm"
                      pStyleClass="@grandparent" enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                      leaveActiveClass="fadeout" (click)="applyFilter(customFilterForm); filterList.hide($event)" aria-label="apply-filters-button">
                    </button>
                  </div>
                  <!-- Dropdown Footer -->
                </ng-template>
              </p-popover>
            </div>

              <div class="hidden md:inline-block" (click)="ExportData()">
                <p-button [loading]="exporting|async" label="{{ 'Shared.PROSPECT.EXPORT_TRIALS'| translate }}" icon="fa fa-file-excel" styleClass="text-sm p-button-text" aria-label="export-trials-button"></p-button>
              </div>
              <div class="md:hidden" (click)="ExportData()">
                <p-button [loading]="exporting|async" icon="fa fa-file-excel" styleClass="p-button-outlined ml-2" aria-label="export-trials-button-mobile"></p-button>
              </div>

            </div>
            <!-- Filter -->

        </div>
      </div>
      <!-- Table Options -->
      <div class="flex align-items-center flex-wrap text-sm mt-1 border-top-1 border-300" *ngIf="showBulkActionBar" aria-label="bulk-actions">
        <!-- Checkbox -->
        <div class="my-2 flex align-items-center mr-2 md:mr-3 white-space-nowrap" aria-label="selected-count">
          <span>{{ selectedClient.size }} Clients selected </span>
          <!-- (<span class="text-primary cursor-pointer"> Select all <strong>{{(totalRecordLength | async).totalItems}} Prospects</strong></span>) -->
          <i class="fa fa-arrow-right ml-3 hidden xl:inline"></i>
        </div>
        <!-- Checkbox -->

        <!-- Create Opportunity -->
        <button pButton pRipple type="button" label="Create Opportunity" (click)="showOpp()"
          class="p-button-text text-xs md:text-sm md:mr-3 md:my-2" icon="fa fa-plus" aria-label="create-opportunity-button">
        </button>
        <!-- Create Opportunity -->

        <!-- Create Tasks -->
        <button pButton pRipple type="button" label="Create Tasks" (click)="newTask()"
          class="p-button-text text-xs md:text-sm md:mr-3 md:my-2" icon="fa fa-list" aria-label="create-tasks-button">
        </button>
        <!-- Create Tasks -->

        <!-- Send Email -->
        <!-- <button pButton pRipple type="button" label="Send Email" class="p-button-text text-xs md:text-sm mr-3 my-2" icon=" fa fa-envelope font-light"></button> -->
        <!-- Send Email -->

         <!-- Changes Sales Rep -->
          <button pButton pRipple type="button" [label]="'CLIENT_PROFILE.CHANGE_CLIENT_REP' | translate" class="p-button-text text-xs md:text-sm md:mr-3"
            icon="fa fa-user-edit" (click)="changeSalesRep()" aria-label="change-sales-rep-button" >
          </button>
       <!-- Changes Sales Rep -->

      </div>
      <!-- Table Options -->
    </div>

    <app-data-grid [loading]="loading" [columnData]="tableData" [totalRecords]="totalRecordLength" [columns]="columns"
      (loadNextData)="fetchNextSetData($event)" [selectable]="selectAllProspectData" (emitValue)="handleEvent($event)"
      (emitSelectValue)="handleSelectAll($event)" (onAction)="onGridAction($event)"
      [EmptyState]="emptyStateComponent$" [resizableColumns]="true" [columnResizeMode]="'expand'"
      aria-label="trial-data-grid" [gridName]="'trial-list'">
    </app-data-grid>
  </div>
</div>
<!-- Body Content-->

<task-create *ngIf="showTaskCreate" [visible]="showTaskCreate" [cltIds]="ClientIds" [readonly]="ClientIds?.length > 0"
  (hide)="HideTaskCreate($event)" aria-label="task-create-dialog">
</task-create>

<!-- Models Prospect Start -->
<!-- <create-prospect *ngIf="showCreateProspectPopup | async as showPopup" [visible]="showPopup"
  (hidePopup)="hidePopup($event)" (GoToClientDetails)="GoToClientDetails($event)"></create-prospect> -->
<!-- Models Prospect End -->

<create-client-profile-sidebar *ngIf="showCreateProspectPopup | async as showPopup" [formType]="'walk-in-trial'" [showProspect]="showPopup" [clientId]="clientId"
(hideProspect)="hidePopup($event)" (proceedToSignup)="proceedToSignup($event)" (GoToClientDetails)="GoToClientDetails($event)" aria-label="create-client-profile-sidebar">
</create-client-profile-sidebar>

<create-opportunity [clientInfo]="getSelectedClientData" [visible]="showCreateOpportunityPopup"
  (hidePopup)="hideOpportunity($event)" aria-label="create-opportunity-dialog"></create-opportunity>
<create-sms *ngIf="toggleCreateSmsDialog$ | async" [createSmsModal]="toggleCreateSmsDialog$ | async"
  [clientData$]="allClients$" (closeCreateSmsDialog)="closeCreateSmsDialog($event)" aria-label="create-sms-dialog"></create-sms>

<!-- Sidebar -->
<client-info-sidebar *ngIf="showClientSidebar" [showClientSidebar]="showClientSidebar" [activeClientId]="activeClientId"
  (closeSidebar)="closeSidebar($event)" aria-label="client-info-sidebar">
</client-info-sidebar>
<!-- Sidebar -->

  <!-- Change Sales Rep Modal  -->
  <change-client-rep-bulk  *ngIf="showChangeSalesRep" [visible]="showChangeSalesRep" [clientData]="clients" [tenantId]="tenantId"
  (closeChangeRepresentativeDialog)="closeChangeSaleRepDialog($event)" aria-label="change-sales-rep-dialog"> 
  </change-client-rep-bulk>
    <!-- Change Sales Rep Modal  -->



<!-- </ion-content> -->



 <!-- Trial History -->
 <p-dialog *ngIf="showTrialHistory | async" [(visible)]="showTrialHistory" [resizable]="false" appendTo="body"
   [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}"
   styleClass="no-header-modal overflow-visible" aria-label="trial-history-dialog">

   <ng-template pTemplate="header" styleClass="hidden"></ng-template>
   <ng-template pTemplate="content" styleClass="p-0">

     <!-- Header -->
     <div class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300" aria-label="trial-history-header">

       <h2 class="mb-0 text-sm" aria-label="trial-history-title">{{'CLIENT_TRIAL.TRIAL_HISTORY' | translate}}</h2>
       <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="CloseTralHistory()" aria-label="close-trial-history"></div>
     </div>
     <!-- Header -->

     <!-- Table -->
     <app-data-grid  [columnData]="trialHistoryData$" [columns]="trialHistoryDataTablecolumns$"
       [selectable]="selecallTrialData" tableClasses="p-0 border-1 border-300"
       [headerClasses]="'text-xs text-600 white-space-nowrap'" [paginator]="false"
       [EmptyState]="emptyStateComponentForHistory$" [EmptyStateClass]="'pt-1 pb-2 text-center surface-0'"
       [resizableColumns]="true" [columnResizeMode]="'expand'" [gridName]="'trial-history-list'">
     </app-data-grid>
     <!-- Table -->

   </ng-template>

 </p-dialog>
 <!-- Trial History -->